import { useEffect } from "react";
import { observer } from "mobx-react-lite";
import { Dialog } from "antd-mobile";
import { useStores } from "../../models";
import useNavigation from "../../hooks/useNavigation";
import { genPrivacyChatID } from "../../utils";

/**
 * 交易室创建后：买家直接进会话，卖家弹确认
 */
const TradingRoomAlert = () => {
  const { orderStore, chatStore, userStore } = useStores();
  const { navigate } = useNavigation();

  useEffect(() => {
    if (orderStore.isTradingRoomAlertShowing || !orderStore.tradingRoomCreatedData) {
      return;
    }
    orderStore.setIsTradingRoomAlertShowing(true);
    const data: any = orderStore.tradingRoomCreatedData;
    const { user_id, seller_id, quantities } = data;
    const currentId = userStore.currentUser?.id;
    const isCurrentUserBuyer = user_id === currentId;
    const other_id = isCurrentUserBuyer ? seller_id : user_id;
    const { chat_id } = genPrivacyChatID(other_id, currentId);

    const goToTradingRoom = () => {
      orderStore.setTradingRoomCreatedData(false);
      orderStore.setIsTradingRoomAlertShowing(false);
      navigate("Chat", { chat_id });
    };

    if (isCurrentUserBuyer) {
      goToTradingRoom();
      return;
    }

    const buyer = userStore.users.get(String(user_id));
    Dialog.confirm({
      title: "交易提醒",
      content: `${buyer?.name || "买家"}购买${quantities}喜鹊币等待您的确认`,
      confirmText: "同意",
      cancelText: "拒绝",
      onConfirm: goToTradingRoom,
      onCancel: () => {
        orderStore.setTradingRoomCreatedData(false);
        orderStore.setIsTradingRoomAlertShowing(false);
      },
    });
  }, [
    orderStore.isTradingRoomAlertShowing,
    orderStore.tradingRoomCreatedData,
    orderStore,
    chatStore,
    userStore,
    navigate,
  ]);

  return null;
};

export default observer(TradingRoomAlert);
